import React, { useEffect, useState } from 'react';

import { emailAPI } from '../../common/api';
import BannerMessage from '../../common/components/banner-message';
import IString from '../../common/components/i-string';
import { getEmailCode, getError, getUserId, getUser } from '../../common/util/server-util';

import * as errors from '../constants/errors';
import { COMPLETE, FAILED, REQUIRED, UPDATE_EMAIL } from '../constants/screens';

import UpdateEmail from './update-email';
import VerificationComplete from './verification-complete';
import VerificationFailure from './verification-failure';
import VerificationRequired from './verification-required';

function Verify() {
  const [email, setEmail] = useState(user?.email || '');
  const [error, setError] = useState(getError());
  const code = getEmailCode();
  const [failure, setFailure] = useState();
  const [pending, setPending] = useState(false);
  const [resent, setResent] = useState(false);
  const [screen, setScreen] = useState();
  const userId = getUserId();
  const user = getUser();

  useEffect(() => {
    setEmail(user?.email || '');
  }, [user]);

  useEffect(() => {
    if (code && userId) {
      emailAPI.verifyEmail(code, userId).then(() => {
        setScreen(COMPLETE);
      }).catch(e => {
        setFailure(e.error_type);
        setScreen(FAILED);
      });
    } else {
      setScreen(REQUIRED);
    }
  }, [code, userId]);

  const resend = () => {
    emailAPI.sendVerificatonEmail().then(() => {
      setError();
      setResent(true);
    }).catch(e => {
      setError(e.data);
      setResent(false);
    });
  };

  const handleUpdateEmail = (newEmail) => {
    setPending(true);
    emailAPI.updateEmail(newEmail).then(() => {
      setEmail(newEmail);
      setScreen(REQUIRED);
    }).catch(e => {
      setError(e.data);
    }).finally(() => {
      setPending(false);
    });
  };

  const onUpdateEmailClick = () => {
    setError();
    setScreen(UPDATE_EMAIL);
  };

  const onBackButtonClick = () => {
    setError();
    setScreen(REQUIRED);
  };

  return (
    <>
      { error && 
        <BannerMessage type='error' className='marginBelow onPage' onClose={() => setError()}>
          { errors.isBannerError(error.error_type) &&
            <IString stringKey={`errors.${error.error_type}`} /> }
          { errors.isUnknownError(error.error_type) && error.error }
        </BannerMessage> }
        
      { resent && 
        <BannerMessage type='info' className='marginBelow onPage' onClose={() => setResent(false)}>
          <IString stringKey='required.resent' />
        </BannerMessage> }

      <div className='fullPageFormContainer marginAbove'>  
        {screen === REQUIRED && <VerificationRequired resend={resend} onUpdateEmailClick={onUpdateEmailClick} email={email} /> }
        
        { screen === FAILED && <VerificationFailure errorType={failure} /> }
        
        { screen === COMPLETE && <VerificationComplete /> }

        {screen === UPDATE_EMAIL && <UpdateEmail email={email} onBackButtonClick={onBackButtonClick} onSubmit={handleUpdateEmail} pending={pending} /> }
      </div>
    </>
  );
}

export default Verify;
